import { Button, ButtonGroup, IconProps, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LoopIcon from '@mui/icons-material/Loop';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddBoxIcon from '@mui/icons-material/AddBox';
import PeopleIcon from '@mui/icons-material/People';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import EditIcon from '@mui/icons-material/Edit';

import * as React from 'react';

const registerNowButton = <Button startIcon={<EventAvailableIcon/>} fullWidth>Register now</Button>
const startTestingButton = <Button startIcon={<LoopIcon/>} fullWidth>Start testing</Button>
const configureTestingButton = <Button startIcon={<SettingsIcon/>} fullWidth>Configure testing</Button>
const viewResultsButton = <Button startIcon={<VisibilityIcon/>} fullWidth>Start testing</Button>

const viewAllUsersButton = (callback: React.MouseEventHandler<HTMLButtonElement>) => <Button onClick={callback} startIcon={<PeopleIcon/>} fullWidth>View all</Button>
const registerOtherUsersButton = <Button startIcon={<PeopleIcon/>} fullWidth>Register other users</Button>
const listParticipantsButton = <Button startIcon={<FormatListBulletedIcon/>} fullWidth>List of all participants</Button>

function createButtonGetter(Icon: JSX.Element, text: string) {
    return (callback:React.MouseEventHandler<HTMLButtonElement>) => <Button startIcon={Icon} onClick={callback}>{text}</Button>
}

//left column
const getViewAllUsersButton = createButtonGetter(<PeopleIcon/>, "View all");
const getRegisterUsersButton = createButtonGetter(<PeopleIcon/>, "Register other users");
const getChangeProductsButton = createButtonGetter(<EditIcon/>, "Change products");
const getViewUserProductsButton = createButtonGetter(<FormatListBulletedIcon/>, "View user & products");
const getAddUserButton = createButtonGetter(<PersonAddIcon/>, "Add User");
const getAddProduct = createButtonGetter(<AddBoxIcon/>, "Add Product");

//right column
const getViewChangeButton = createButtonGetter(<EditIcon/>, "View/Change");
const getListParticipantsButton = createButtonGetter(<FormatListBulletedIcon />, "List of all participants");


export interface ButtonPanelProps2 {
    heading?: string | null
    children: React.ReactNode[] | React.ReactNode
}

export const VerticalButtonPanel = ({heading, children}: ButtonPanelProps2) => {
    const childrenArray = React.Children.toArray(children);
    const insHeading = (typeof heading !== "undefined")?heading:" ";

    childrenArray.unshift(
        <Grid size={12} sx={{borderColor: 'lightgrey'}}>
            <Typography variant="bold" height="100%">{insHeading}</Typography>
        </Grid>);

    const gridChildren = childrenArray.map(child => <Grid size={12} height="100%">{child}</Grid>);

    return <Grid container borderTop={1} size={12} rowGap={5} paddingBottom={10} borderBottom={1} sx={{borderColor: 'lightGrey'}}>{gridChildren}</Grid>
}

export interface ButtonPanelProps {
    columnHeadingLeft: string,
    columnHeadingRight: string

    viewAllUsersCallback?: React.MouseEventHandler<HTMLButtonElement>,
    registerUsersCallback?: React.MouseEventHandler<HTMLButtonElement>
    changeProductsCallback?: React.MouseEventHandler<HTMLButtonElement>
}

export const ButtonPanel = ({columnHeadingLeft, columnHeadingRight,
                             viewAllUsersCallback, registerUsersCallback, changeProductsCallback}: ButtonPanelProps) => {
    let buttonsLeft: JSX.Element[] = []

    if(typeof changeProductsCallback !== "undefined")
        buttonsLeft.push(getChangeProductsButton(changeProductsCallback));
    if(typeof viewAllUsersCallback !== "undefined")
        buttonsLeft.push(getViewAllUsersButton(viewAllUsersCallback));
    if(typeof registerUsersCallback !== "undefined")
        buttonsLeft.push(getRegisterUsersButton(registerUsersCallback));
    

    return <Grid container spacing={20}>
        <Grid size={6}>
            <Grid size={12}>
                <Typography variant="bold">{columnHeadingLeft}</Typography>
            </Grid>
            <Grid size={12}>
                <ButtonGroup orientation='vertical' fullWidth>
                    {buttonsLeft}
                    {registerOtherUsersButton}
                </ButtonGroup>
            </Grid>
        </Grid>
        <Grid size={6}>
            <Grid size={12}>
                <Typography variant="bold">{columnHeadingRight}</Typography>
            </Grid>
            <Grid size={12}>
                <ButtonGroup fullWidth>
                    {listParticipantsButton}
                </ButtonGroup>
            </Grid>
        </Grid>
    </Grid>
}